import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fgroup',
  templateUrl: './fgroup.component.html',
  styleUrls: ['./fgroup.component.sass']
})
export class FgroupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
